/**
 * Strikter Origin-Vergleich mit optionalem Subdomain-Wildcard.
 *
 * Ersetzt das unreife Paket `match-url-wildcard` (0.0.x) durch eine geprüfte,
 * bewusst restriktive Eigenimplementierung: verglichen werden vollständige
 * Origins (Schema + Host + optionaler Port), `*` steht ausschließlich für
 * ein oder mehrere Subdomain-Label (z. B. `https://*.review.example.app`).
 *
 * @param origin  Tatsächlicher Origin (z. B. aus MessageEvent.origin)
 * @param pattern Erlaubter Origin, optional mit `*`-Subdomain-Wildcard
 */
export function matchesOriginPattern(origin: string, pattern: string): boolean {
  if (!origin || !pattern) {
    return false;
  }
  if (pattern === origin) {
    return true;
  }
  if (!pattern.includes('*')) {
    return false;
  }
  // Regex-Sonderzeichen escapen (ohne '*'), dann '*' auf Subdomain-Label mappen.
  const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&');
  const regexSource = escaped.replace(/\*/g, '[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*');
  return new RegExp(`^${regexSource}$`).test(origin);
}
